import React from 'react';
import {
  Button,
  FormWithRedirect,
  SaveButton,
  TextInput,
  useNotify,
  useRefresh,
  useUpdate,
} from 'react-admin';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import IconCancel from '@material-ui/icons/Cancel';

const useStyles = makeStyles(() => ({
  serviceList: {
    color: '#888',
    marginBottom: 3,
  },
  listLabel: {
    fontWeight: '600',
    color: '#000',
  },
  root: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
    '& .MuiFormHelperText-contained': {
      display: 'none',
    },
  },
  btnCancel: {
    backgroundColor: '#fdfdfd',
    height: 37,
    marginRight: 10,
    padding: 10,
    color: '#212B36',
    border: '1px solid rgba(145, 158, 171, 0.24)',
    borderRadius:8
  },
}));

const UnifiedEditNotes = ({
  admin_note,
  customer_diagnostic_note,
  customer_schedule_note,
  customer_note,
  customer_tire_note,
  vehicle_service_requirements_note,
  customer_home_additional_note,
  key_exchange_note,
  technician_note,
  payment_note,
  id,
  setIsEditing,
}) => {
  const previousData = {
    admin_note,
    customer_diagnostic_note,
    customer_schedule_note,
    customer_note,
    customer_tire_note,
    vehicle_service_requirements_note,
    customer_home_additional_note,
    key_exchange_note,
    technician_note,
    payment_note,
  };
  const notify = useNotify();
  const refresh = useRefresh();
  const [update] = useUpdate('scheduled-work');
  const handleSubmit = async (values) => {
    update(
      { payload: { id, data: values, previousData } },
      {
        onSuccess: () => {
          setIsEditing(false);
          notify('Notes updated successfully');
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, 'error');
        },
      },
    );
  };
  const classes = useStyles();
  return (
    <>
      <FormWithRedirect
        resource="scheduled-work"
        record={previousData}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <Grid container spacing={1} className={`${classes.root} schedule_work_section`}>
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="body2" className={classes.serviceList}>
                  <u>
                    <span className={classes.listLabel}>
                      Customer Provided:
                    </span>
                  </u>
                </Typography>
                <TextInput multiline source="customer_note" />
                <TextInput multiline source="customer_tire_note" />
                <TextInput multiline source="customer_diagnostic_note" />
                <TextInput multiline source="customer_schedule_note" />
                <TextInput multiline source="key_exchange_note" />
                <TextInput
                  multiline
                  source="vehicle_service_requirements_note"
                />
                <TextInput multiline source="customer_home_additional_note" />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="body2" className={classes.serviceList}>
                  <u>
                    <span className={classes.listLabel}>
                      Employee Provided:
                    </span>
                  </u>
                </Typography>
                <TextInput
                  multiline
                  source="admin_note"
                  label="Admin Note (Not visible to customer)"
                />
                <TextInput
                  multiline
                  source="payment_note"
                  label="Payment Note (Not visible to customer)"
                />
                <TextInput multiline source="technician_note" />
              </Grid>
            </Grid>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              my={2}
            >
              <Button
                label="ra.action.cancel"
                onClick={() => setIsEditing(false)}
                className={classes.btnCancel}
              >
                <IconCancel />
              </Button>
              <SaveButton
                handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                saving={formProps.loading}
                disabled={formProps.pristine}
              />
            </Box>
          </>
        )}
      />
    </>
  );
};

export default UnifiedEditNotes;
